import { createFileRoute } from '@tanstack/react-router';

import { LayersHarnessPage } from '../__e2e__/layers';

export const Route = createFileRoute('/$e2eSegment/layers')({
  component: E2ELayersAliasRoute,
});

function E2ELayersAliasRoute() {
  const { e2eSegment } = Route.useParams();

  if (e2eSegment !== '__e2e__') {
    return <div className="placeholder">Not Found</div>;
  }

  return <LayersHarnessPage />;
}
